import { RacingTracks } from "@/constants/tracks/RacingTracks";

import { MetaInfoTypes } from "../brandVariables.types";

export const legoMeta: MetaInfoTypes = {
  trackName: "Austrian Grand Prix - Red Bull Ring",
  playerTeamOrCarKey: "",
  playerTeamOrCarValue: "",
  team: "",
  map: RacingTracks["LEGO-gdjkr"],
  1: {
    key: "Turns:",
    value: "10",
  },
  2: {
    key: "Length:",
    value: "4.318 km",
  },
  3: {
    key: "Difficulty:",
    value: "easy",
  },
  4: {
    key: "Record:",
    value: "1:05.619",
  },
};
